module.exports = __webpack_public_path__ + "img/default-selfie.701c81f7.png";